// extracted by mini-css-extract-plugin
module.exports = {"base":"ClusterLogs_base__2t-Wq","title":"ClusterLogs_title__1keVr"};